import React from 'react';
import styled from '@emotion/styled';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
  width: 100%;
`;

const Label = styled.label`
  font-size: 0.8rem;
  margin-bottom: 5px;
  text-align: left;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  background-color: ${props => props.missing ? '#ffdddd' : 'white'};
  font-size: 16px;
`;

const SelectWithLabel = ({ label, options, required = false, missing = false, visible = true, ...selectProps }) => {
  return (
    <InputContainer style={{ display: visible ? 'flex' : 'none' }}>
      {options && <>
        <Label>
          {label}
          {required && <span style={{ color: '#880808' }}> *</span>}
        </Label>
        <Select missing={missing} {...selectProps}>
          {options.map((option, index) => (
            <option key={index} value={option.value || ''}>
              {option.label}
            </option>
          ))}
        </Select></>}
    </InputContainer>
  );
};

export const YesNoSelect = ({ label, required = false, missing = false, useNumbers = false, ...selectProps }) => {
  const yesNo = [
    { label: 'No', value: 'No' },
    { label: 'Yes', value: 'Yes' }
  ];

  const yesNoNumber = [
    { label: 'No', value: 0 },
    { label: 'Yes', value: 1 }
  ];

  return (
    <InputContainer>
      <Label>
        {label}
        {required && <span style={{ color: '#880808' }}> *</span>}
      </Label>
      <Select missing={missing} {...selectProps}>
        {useNumbers &&
          (
            yesNoNumber.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))
          )
        }
        {!useNumbers && (
          yesNo.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          )))}
      </Select>
    </InputContainer>
  );
}

export default SelectWithLabel;
